/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { ISubscriptionRestrictionButtonViewProps } from './subscription-restriction-button';

const ContentBlockView: React.FC<ISubscriptionRestrictionButtonViewProps> = props => {
    const {
        contentBlockContainer,
        className,
        imageContainer,
        detailsContainer,
        title,
        text,
        links,
        image,
        hasFrequency,
        hasName,
        config: {
            requireFrequency,
            requireName
        }
    } = props;

    let shouldDisable = false;

    if (requireFrequency && !hasFrequency) {
        shouldDisable = true;
    }
    if (requireName && !hasName) {
        shouldDisable = true;
    }

    return (
        <Module {...contentBlockContainer} className={classnames('ms-content-block', className, { 'subscription-add__disabled': shouldDisable })}>
            <Node {...imageContainer}>
                {image}
            </Node>
            <Node {...detailsContainer}>
                {title}
                {text}
                {links}
            </Node>
        </Module>
    );
};

export default ContentBlockView;
